export const ArticleTypeLabel = {
  0: 'Almacenable',
  1: 'Consumible'
}
